import questionImg from '../../images/question.webp';

export const HelpBanner = () => {
  return (
    <div
      className={`
        box-border flex h-min w-full max-w-[434px] flex-col items-center
        gap-[6px] rounded-2xl border border-solid border-[#EAECEE] px-4 pt-4
        pb-10
      `}
    >
      <img src={questionImg} width={77} height={77} alt="" />
      <h6 className="my-0 text-center font-heading text-2xl font-bold">
        Having questions?
      </h6>
      <p className="my-0 max-w-[256px] text-center font-body">
        Email us at&nbsp;
        <a href="mailto:pos-support@skyro.ph" className="text-primary">
          pos-support@skyro.ph
        </a>{' '}
        or contact your key&nbsp;account manager
      </p>
    </div>
  );
};
